<template src="./MenuIcon.html"> </template>

<script>
export default {
    name: 'MenuIcon',
    props: {
        icon: {
            required: true,
            type: String
        }
    }
}
</script>

<style lang="scss" src="./MenuIcon.scss"> </style>